var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout flex-center"},[_c('div',{staticClass:"container flex-column"},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"logo"})]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }